import fe, { info } from "@randajan/simple-app/fe";
import jet from "@randajan/jet-core";
import { page } from "../bases/page";

export const usePageContact = ()=>{
    const [ pageContact ] = page.use("hash.contact");
    const isOpen = !!pageContact.get();

    const setState = (state)=>{
        if (state === isOpen) { return; }
        if (isOpen) { pageContact.remove(); }   
        else { pageContact.set("", "up"); }
    }

    return [ isOpen, setState ];
}